<div class="upd-dialog">
  <div class="upd-header">
    <h2 class="upd-title">
      {{
        'leave_management.upload_leave_policy_dialog.upload_leave_policy_document'
          | transloco
      }}
    </h2>
    <button
      class="lm-dialog-close-btn lm-dialog-close-circle"
      [lmTooltip]="'Close'"
      tooltipPosition="left"
      (click)="onCancel()"
      [attr.aria-label]="
        'leave_management.upload_leave_policy_dialog.aria_label.close'
          | transloco
      "
    >
      <mat-icon>{{
        'leave_management.upload_leave_policy_dialog.close' | transloco
      }}</mat-icon>
    </button>
  </div>

  <div class="lm-dialog-divider"></div>

  <div class="upd-body">
    <!-- File / Leave Type selector -->
    <div class="upd-field-group upd-field-group--row">
      <label class="upd-field-label">
        File <span class="upd-req">*</span>
      </label>
      <mat-form-field appearance="outline" class="upd-leave-type-select">
        <mat-select
          [multiple]="true"
          [(ngModel)]="selectedLeaveTypes"
          (ngModelChange)="onModelChange($event)"
          panelClass="upd-select-panel"
          [placeholder]="
            'leave_management.upload_leave_policy_dialog.placeholder.select_leave_type'
              | transloco
          "
        >
          <mat-option [value]="SELECT_ALL">{{
            'leave_management.upload_leave_policy_dialog.select_all' | transloco
          }}</mat-option>
          @for (lt of leaveTypes | ersSortBy: 'label'; track lt.value) {
          <mat-option [value]="lt.value">
            {{ lt.label }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Drop zone -->
    <div
      class="upd-dropzone"
      [class.upd-dropzone--active]="isDragging"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()"
      (drop)="onDrop($event)"
      (click)="onDropzoneClick()"
     ersClickable>
      <div class="upd-upload-circle">
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
          <path
            d="M19 26V14M19 14L14 19M19 14L24 19"
            stroke="#1a6fb5"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 28h18"
            stroke="#1a6fb5"
            stroke-width="2.2"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <p class="upd-drop-text">
        {{
          'leave_management.upload_leave_policy_dialog.drag_amp_drop_files_here_or_click_to'
            | transloco
        }}
      </p>
      <input
        #fileInput
        type="file"
        hidden
        multiple
        accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
        (change)="onFileSelected($event)"
      />
    </div>

    <div class="upd-info-row">
      <mat-icon class="upd-info-icon">{{
        'leave_management.upload_leave_policy_dialog.info' | transloco
      }}</mat-icon>
      <span class="upd-info-text">{{
        'leave_management.upload_leave_policy_dialog.file_size_should_not_exceeded_than_99mb'
          | transloco
      }}</span>
    </div>

    <!-- Selected files list -->
    @if (selectedFiles.length > 0) {
    <div class="upd-file-list">
      @for (file of selectedFiles; track file.name; let i = $index) {
      <div class="upd-file-item">
        <mat-icon class="upd-pdf-icon">{{
          'leave_management.upload_leave_policy_dialog.picture_as_pdf'
            | transloco
        }}</mat-icon>
        <span class="upd-selected-name">{{ file.name }}</span>
        <span class="upd-file-size"
          >{{ file.size / 1024 / 1024 | number : '1.1-1' }} MB</span
        >
        <button
          class="upd-remove-btn"
          [lmTooltip]="'Remove file'"
          tooltipPosition="top"
          (click)="removeFile(i)"
          [attr.aria-label]="
            'leave_management.upload_leave_policy_dialog.aria_label.remove_file'
              | transloco
          "
        >
          <mat-icon>{{
            'leave_management.upload_leave_policy_dialog.close' | transloco
          }}</mat-icon>
        </button>
      </div>
      }
    </div>
    }
  </div>

  <div class="upd-footer">
    <button class="lm-btn lm-btn--reset" (click)="onCancel()">
      {{ 'leave_management.upload_leave_policy_dialog.cancel' | transloco }}
    </button>
    <button
      class="lm-btn lm-btn--primary"
      [disabled]="selectedFiles.length === 0"
      (click)="onUpload()"
    >
      Upload{{
        selectedFiles.length > 1 ? ' (' + selectedFiles.length + ' files)' : ''
      }}
    </button>
  </div>
</div>
